var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("h1", [_vm._v("Contact us")]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "\n      Reach out to us if you have enquiries or assistance needed by contacting\n      " +
              _vm._s(_vm.tenant != "" ? _vm.tenant.toUpperCase() : "UNIFI") +
              " at\n      "
          ),
          _c("strong", [_vm._v(_vm._s(_vm.contactNumber))]),
          _vm._v("\n      or email us\n      "),
          _c(
            "a",
            { attrs: { target: "_blank", href: "mailto:" + _vm.contactEmail } },
            [_vm._v(_vm._s(_vm.contactEmail))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bigImg" })
      ]),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4a6b714", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4a6b714","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/more/contact.vue
// module id = null
// module chunks = 